import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { Location } from "@angular/common"
// import { CommonService } from './common.service';
import { HttpClient } from '@angular/common/http';
// import * as CryptoJS from 'crypto-js';
import { AuthService } from '../services/auth.service';
import { environment } from 'src/environments/environment';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit, OnChanges {
  @Input() formFields: any = [];
  @Input() signUpFormFields: any = [];
  // @Output() emitSigUpDetails = new EventEmitter<any>();
  @Input() loginDetails: any
  @Input() signUpDetails: any
  @Output() formData = new EventEmitter<any>();
  // @Output() signUpValues = new EventEmitter<any>();
  dynamicForm!: FormGroup;
  // @Output() regEmail: any = new EventEmitter<any>();
  // @Output() credentials: any = new EventEmitter<any>();
  // @Output() otp: any = new EventEmitter<any>();
  @Input() sendEmail: any
  @Input() forgotPasswordData: any = [];
  placeholderClass = true
  show: boolean = false;
  @Output() crossIcon = new EventEmitter<any>();
  @Output() fData = new EventEmitter<any>();
  @Input() sessionApiEndPoint: any
  imageCaptcha: any;
  visible: boolean = false;
  showHideText: any = 'Show';
  loginAsCSE: boolean = false;
  roleName:string;
  roleId:number;

  ngOnChanges(changes: SimpleChanges) {
    // this.formFields = changes['formFields']?.currentValue;
    // console.log(changes);
    // this.forgotPasswordData = changes['forgotPasswordData']?.currentValue[0];

    this.sessionApiEndPoint = changes['sessionApiEndPoint']?.currentValue;
    this.sessionCreate(this.sessionApiEndPoint);

    // this.signUpFormFields = changes['signUpFormFields']?.currentValue;
    this.createForm();
    // console.log(this.sendEmail);
    this.service.sendResponse.next(this.sendEmail);
  }

  close() {
    this.visible = true;
    this.crossIcon.emit(this.visible);
  }

  forgotPassword() {

    this.service.changeForgotData(this.forgotPasswordData)
    localStorage.setItem('forgotPasswordData', JSON.stringify(this.forgotPasswordData))
    this.router.navigate(['/login/forgot-password'])
  }
  password() {

    if (this.showHideText == 'Hide') {
      this.showHideText = 'Show';
    } else {
      this.showHideText = 'Hide';
    }
    this.show = !this.show;
  }

  constructor(public router: Router, private route: ActivatedRoute, private location: Location, private service: AuthService) {
    this.service.receiveForgotData.subscribe((res: any) => {
      // console.log(res)
      let data = res
      this.fData.emit(data);
    })
    // this.service.allDetails.subscribe((res: any) => {
    //   this.regEmail.emit(res)
    //   // console.log(this.regEmail);
    //   this.createForm()
    // })


    // this.service.currentSource.subscribe((res: any) => {
    //   // console.log(res);
    //   this.signUpValues.emit(res)
    // })


  }

  ngOnInit(): void {
    this.route.queryParams.subscribe(params => {
      // Decode roleName and roleId using atob
      this.roleName='Login as Facility'
      this.roleId=2;
      if(params['roleName']){
        const decodedRoleName = atob(params['roleName']);
        this.roleName=decodedRoleName;
      }
      if(params['roleId']){
        const decodedRoleId = atob(params['roleId']);
        this.roleId=Number(decodedRoleId);
      }
     
    });
    

    console.log(this.loginAsCSE);
    
    //receive email
    // this.service.changeData.subscribe((res: any) => {
    //   // console.log(res);
    //   this.credentials.emit(res)
    // })

    //receive otp
    // this.service.otp.subscribe((res: any) => {
    //   // console.log(res);
    //   // this.otp.emit(res)
    // })
  }

  // receiveMail(event: any) {
  //   // console.log(event);

  // }

  signUp() {
    // console.log(this.signUpFormFields);
    localStorage.clear();
    // this.service.changeSource(this.signUpFormFields)
    // this.service.changeDetail(this.signUpDetails)
    localStorage.setItem('signUpFormFields', JSON.stringify(this.signUpFormFields))
    localStorage.setItem('signUpDetails', JSON.stringify(this.signUpDetails))
    this.router.navigate(['/sign-up'])
  }

  createForm() {
    // console.log(this.formFields);

    let controls: any = {};
    this.formFields?.forEach((res: any) => {
      let validationsArray: any = [];
      res?.validations?.forEach((val: any) => {
        if (val?.name === 'required') {
          validationsArray.push(
            Validators?.required
          );
        }
        if (val?.name === 'pattern') {
          validationsArray.push(
            Validators?.pattern(val?.validator)
          );
        }
      });
      controls[res?.label] = new FormControl('', validationsArray);

    });

    let captchaText: any;
    captchaText = new FormControl('');

    this.dynamicForm = new FormGroup(
      { ...controls, captchaText }
    );

    // console.log({ obj: this.dynamicForm, captchaText })
  }

  get form() {
    return this.dynamicForm?.controls
  }


  onSubmit() {
    // console.log(this.dynamicForm.value);
    
    // accessType: 1 for ADMIN user
    // let emitValue = this.loginAsCSE ? {...this.dynamicForm.value, accessType: 1} : this.dynamicForm.value;
    let emitValue = {...this.dynamicForm.value, accessType: this.roleId} ;
    sessionStorage.setItem('user-role',JSON.stringify(this.roleName))
    this.formData.emit(emitValue)
    // if(this.loginAsCSE){
    // this.formData.emit({...this.dynamicForm.value, accessType: 1});
    // }else{
    // this.formData.emit(this.dynamicForm.value)
    // }
  }

  // receiveData(event: any) {
  //   // console.log(event);
  // }

  sessionCreate(ePoint: any) {
    this.service.createSession(ePoint).subscribe((res: any) => {
      // console.log(res);
      this.imageCaptcha = res?.data?.captcha;
      // this.sessionId = res?.data?.id;
    })
  }

  refreshCaptcha() {
    this.sessionCreate(this.sessionApiEndPoint);
    this.dynamicForm.get('captchaText')?.reset();
  }

  // receiveFData(event: any) {
  //   console.log(event)
  // }

  loginAsCSEClicked() {
    this.loginAsCSE = true;
  }
  loginAsFacilityClicked(){
    this.loginAsCSE = false;
  }
  locationBack(){
    this.location.back();
  }
}